(function () {
  'use strict';

  angular
    .module('iqxCore')
    .run(run)

  function run($rootScope, $location, ApplicationSvc, loginSvc, ngProgress, SweetAlert, toastSvc, pinSvc, webViewSvc, authSvc) {
    webViewSvc.check()
    $rootScope.isRouteLoading = false
    $rootScope.progressbar = ngProgress
    $rootScope.progressbar.start()

    // Register listener to watch route changes
    $rootScope.$on('$routeChangeStart', function (event, next, current) {
      $rootScope.isRouteLoading = true

      if (localStorage.getItem('isLoggedIn') === 'true') {
        authSvc.renewTokens();
      } else {
        // Handle the authentication
        // result in the hash
        authSvc.handleAuthentication();
      }
      // Schedule the token to be renewed
      authSvc.scheduleRenewal();

      pinSvc.setPage = next.originalPath
      // Set the page for pin authentication
      if (ApplicationSvc.isLoggedIn && ApplicationSvc.currentUser.pinauth) {
        if (pinSvc.checkAuth()) {
          $location.path("/pin");  // Redirect
        }
      }

      if (!next) { return } // next can be undefined - back?

      if (ApplicationSvc.forceChangePassword() && next.originalPath !== '/changepassword') {
        ApplicationSvc.postLoginRoute = next.originalPath  // Remember where they requested to go so we can still go there after they change password
        $location.path("/changepassword");  // Redirect
      } else if (ApplicationSvc.currentUser.LastLoggedIn === "" && !ApplicationSvc.currentUser.welcomeMessageShown && checkIfSwitchedOn("WELCOME_" + ApplicationSvc.currentUser.UserClass.toUpperCase())) {
        ApplicationSvc.postLoginRoute = next.originalPath  // Remember where they requested to go so we can still go there after they change password
        ApplicationSvc.currentUser.welcomeMessageShown = true // without this they would always be thrown to the welcome page...
        $location.path("/welcome-" + ApplicationSvc.currentUser.UserClass.toLowerCase());  // Redirect
      }
    })

    var checkIfSwitchedOn = function (switchName) {
      return ApplicationSvc.currentUser.Switches.indexOf(switchName) > -1
    }

    $rootScope.$on('$routeChangeSuccess', function (event, next, current) {
      $rootScope.isRouteLoading = false
      $rootScope.progressbar.complete()
    })

    $rootScope.$on('$locationChangeStart', function (event, newUrl) {
      if (ApplicationSvc.openedModalDialog) {
        event.preventDefault()
        ApplicationSvc.openedModalDialog.dismiss()
      } else if (ApplicationSvc.isEditing && ApplicationSvc.preventNavIfEditing && ApplicationSvc.isLoggedIn) {
        var newPath = $location.path()
        event.preventDefault()
        $rootScope.isRouteLoading = false
        SweetAlert.swal({
          title: "Unsaved Changes",
          confirmButtonText: "Discard Changes",
          confirmButtonColor: "#337ab7",
          type: "warning",
          text: 'Are you sure you want to discard unsaved changes?',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(function (result) {
          if (result.value) {
            ApplicationSvc.preventNavIfEditing = false
            $rootScope.$evalAsync(function () { // tell AngularJS about a data change
              $location.path(newPath)
            })
          }
        })
      }
    })

    $rootScope.$on('$routeChangeError', function (e) {
      toastSvc.error('Error', 'Error loading page.', 'pageerror')
    })
  }

})()